var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuDotsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 16,
    viewBox: "0 0 5 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.3999 4C3.4999 4 4.3999 3.1 4.3999 2C4.3999 0.9 3.4999 0 2.3999 0C1.2999 0 0.399902 0.9 0.399902 2C0.399902 3.1 1.2999 4 2.3999 4ZM2.3999 6C1.2999 6 0.399902 6.9 0.399902 8C0.399902 9.1 1.2999 10 2.3999 10C3.4999 10 4.3999 9.1 4.3999 8C4.3999 6.9 3.4999 6 2.3999 6ZM2.3999 12C1.2999 12 0.399902 12.9 0.399902 14C0.399902 15.1 1.2999 16 2.3999 16C3.4999 16 4.3999 15.1 4.3999 14C4.3999 12.9 3.4999 12 2.3999 12Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuDotsIcon);
export default __webpack_public_path__ + "static/media/menu-dots-icon.83238baf8a8a7c3a56c40b422322828b.svg";
export { ForwardRef as ReactComponent };